export interface EditFundingSourceInputData {
  earningInfo: {
    grossPayment: number;
    totalDeductions: number;
    netPayment: number;
  };
}
